import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { DateUtil } from '../../common-app/util/date-util';
import { Kvaw0800Service } from '../../service/kvaw0800.service';
import { SentReportModel, Kvaw0800Vo } from '../../service/kvaw0800.vo';
import { SentReportViewModel } from './kvap0400.view-model';

@Component({
  templateUrl: './kvap0400.component.html',
  providers: [Kvaw0800Service]
})
export class Kvap0400Component implements OnInit {

  public sentReports: SentReportViewModel[] = [];

  constructor(
    private kvaw0800Service: Kvaw0800Service,
    private router: Router,
  ) { }

  /**
   * 初期処理
   */
  ngOnInit() {
    this.searchSentReportsObservable().subscribe();
  }

  /**
   * 送信済日報一覧を検索する
   */
  searchSentReportsObservable(): Observable<Kvaw0800Vo> {
    return this.kvaw0800Service.searchSentReports()
      .map(responseVo => {
        // 表示用に値を変換
        this.sentReports = responseVo.sentReportList
          .sort((report1, report2) => {
            const retVal =
              DateUtil.parseYYYYMMDD(report2.deliveryDate).getTime() -
              DateUtil.parseYYYYMMDD(report1.deliveryDate).getTime() +
              report1.storeName.localeCompare(report2.storeName);
            return retVal;
          })
          .map(report => <SentReportViewModel>{
            groupCompanyCode: report.groupCompanyCode,
            storeCode: report.storeCode,
            storeName: report.storeName,
            deliveryDate: report.deliveryDate,
            receptionDate: report.receptionDate,
            receptionTime: report.receptionTime,
            outsideFlg: report.outsideFlg,
            chainCode: report.chainCode,
            chainCodeBranchNum: report.chainCodeBranchNum,
            kaibaCode: report.kaibaCode,
            formattedDeliveryDate: DateUtil.formatMDddd(report.deliveryDate),
          });
        return responseVo;
      });
  }

  /**
   * 日報報告画面に遷移する.
   */
  report(model: SentReportModel) {
    if (model.outsideFlg) {
      this.router.navigate(['/kvap0800'], {
        queryParams: {
          storeCode: model.storeCode,
          deliveryDate: model.deliveryDate,
          isSent: 'true',
          outsideFlg: 'true',
          chainCode: model.chainCode,
          chainCodeBranchNum: model.chainCodeBranchNum,
          kaibaCode: model.kaibaCode
        }
      });
    } else {
      this.router.navigate(['/kvap0800'], {
        queryParams: {
          storeCode: model.storeCode,
          deliveryDate: model.deliveryDate,
          isSent: 'true'
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/component/kvap0400/kvap0400.component.ts